import { render, staticRenderFns } from "./KFileField.vue?vue&type=template&id=55102a46&scoped=true&"
import script from "./KFileField.vue?vue&type=script&lang=js&"
export * from "./KFileField.vue?vue&type=script&lang=js&"
import style0 from "./KFileField.vue?vue&type=style&index=0&id=55102a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55102a46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFileInput,VIcon,VImg,VRow})
